import { Bloc } from "@kernel/frontend-react-app";
import { RoomState, defaultRoomState } from "./RoomState";
import { RoomBloc } from "./RoomBloc";

export type RoomSettingsBlocState = Pick<
  RoomState,
  "showParticipants" | "layout"
>;

export class RoomSettingsBloc extends Bloc<RoomSettingsBlocState> {
  public constructor() {
    super({
      showParticipants: defaultRoomState.showParticipants,
      layout: defaultRoomState.layout
    });
  }

  public toggleParticipants(): void {
    this.changeState({
      ...this.state,
      showParticipants: !this.state.showParticipants
    });
  }

  public toggleLayout(): void {
    this.changeState({
      ...this.state,
      layout: this.state.layout === "speaker" ? "grid" : "speaker"
    });
  }

  public static create(parent: RoomBloc): RoomSettingsBloc {
    const bloc = new RoomSettingsBloc();
    bloc.subscribe((state: RoomSettingsBlocState) => {
      parent.changeState({
        ...parent.state,
        showParticipants: state.showParticipants,
        layout: state.layout
      });
    });
    return bloc;
  }
}
